import { MytennightsTestId } from '@lib/testing'
import { gmErrorMessage } from '@shamaazi/mytennights'
import { type FC } from 'react'

export const GMErrorMessage: FC<{ error: Error | null, chainCode?: string }> = ({ error, chainCode }) => {
  if (error && chainCode) return <p data-test-id={MytennightsTestId.givematchErrorMessage} className="mt-5 w-11/12 sm:w-3/4 rounded font-medium text-center text-mtn-red ">{gmErrorMessage}</p>
  return <></>
}
